<app-table
    [items]="store.items()"
    [columns]="columns"
    translatePrefix="person.dashboard.dataShare."
    [hideCheckboxes]="true"
    (detailCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
>
</app-table>
